/**
 * Bird Buddy Product Card JavaScript
 * 处理UGC视频播放和产品变体切换功能
 */

class BirdBuddyProductCard {
  constructor() {
    this.init();
  }

  init() {
    // this.setupUGCVideoHandlers();
    this.setupVariationSwappers();
    this.setupAddToCartHandlers();
    // this.loadVideoSources();
    
    // 确保全局的加购功能正确初始化
    if (typeof getAddToCartElements === 'function') {
      const productSection = document.querySelector('.shop-products-tabs');
      if (productSection) {
        getAddToCartElements(productSection);
      }
    }
  }

  /**
   * 设置UGC视频播放处理
   */
  setupUGCVideoHandlers() {
    // 打开视频按钮
    document.addEventListener('click', (e) => {
      if (e.target.closest('.nm-shop-loop-product-ugc-button--open')) {
        e.preventDefault();
        const button = e.target.closest('.nm-shop-loop-product-ugc-button--open');
        const productCard = button.closest('.nm-shop-loop-product-wrap');
        this.openUGCVideo(productCard);
      }
    });

    // 关闭视频按钮
    document.addEventListener('click', (e) => {
      if (e.target.closest('.nm-shop-loop-product-ugc-button--close')) {
        e.preventDefault();
        const button = e.target.closest('.nm-shop-loop-product-ugc-button--close');
        const productCard = button.closest('.nm-shop-loop-product-wrap');
        this.closeUGCVideo(productCard);
      }
    });

    // 点击视频内容区域外关闭
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('nm-shop-loop-product-ugc-content')) {
        this.closeUGCVideo(e.target.closest('.nm-shop-loop-product-wrap'));
      }
    });

    // ESC键关闭视频
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeVideo = document.querySelector('.nm-shop-loop-product-ugc-content.active');
        if (activeVideo) {
          this.closeUGCVideo(activeVideo.closest('.nm-shop-loop-product-wrap'));
        }
      }
    });
  }

  /**
   * 打开UGC视频
   */
  openUGCVideo(productCard) {
    const ugcContent = productCard.querySelector('.nm-shop-loop-product-ugc-content');
    const video = productCard.querySelector('.nm-shop-loop-product-ugc-video');
    
    if (ugcContent && video) {
      ugcContent.classList.add('active');
      
      // 设置视频源（如果还没有设置）
      if (!video.src) {
        const productHandle = video.dataset.productHandle;
        video.src = this.getVideoSource(productHandle);
      }
      
      // 播放视频
      video.play().catch(console.warn);
      
      // 暂停其他正在播放的视频
      this.pauseOtherVideos(video);
    }
  }

  /**
   * 关闭UGC视频
   */
  closeUGCVideo(productCard) {
    const ugcContent = productCard.querySelector('.nm-shop-loop-product-ugc-content');
    const video = productCard.querySelector('.nm-shop-loop-product-ugc-video');
    
    if (ugcContent && video) {
      ugcContent.classList.remove('active');
      video.pause();
      video.currentTime = 0;
    }
  }

  /**
   * 暂停其他正在播放的视频
   */
  pauseOtherVideos(currentVideo) {
    const allVideos = document.querySelectorAll('.nm-shop-loop-product-ugc-video');
    allVideos.forEach(video => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
        const ugcContent = video.closest('.nm-shop-loop-product-ugc-content');
        if (ugcContent) {
          ugcContent.classList.remove('active');
        }
      }
    });
  }

  /**
   * 根据产品handle获取视频源
   */
  getVideoSource(productHandle) {
    const videoMap = {
      'smart-bird-feeder-pro': '/assets/ugc-pro.mp4',
      'smart-hummingbird-feeder': '/assets/ugc-hbf.mp4',
      'nature-station': '/assets/ugc-station.mp4',
      'default': '/assets/ugc-default.mp4'
    };
    
    return videoMap[productHandle] || videoMap['default'];
  }

  /**
   * 预加载视频源
   */
  loadVideoSources() {
    const videos = document.querySelectorAll('.nm-shop-loop-product-ugc-video');
    videos.forEach(video => {
      const productHandle = video.dataset.productHandle;
      if (productHandle) {
        video.src = this.getVideoSource(productHandle);
        video.preload = 'metadata';
      }
    });
  }

  /**
   * 设置添加购物车处理
   */
  setupAddToCartHandlers() {
    // 使用系统的 global.js 处理加购逻辑
    // 确保产品卡片区域内的加购按钮被初始化
    const productCards = document.querySelectorAll('.product-card')
    productCards.forEach(card => {
      const addToCartButton = card.querySelector('[data-add-to-cart]')
      if (addToCartButton && !addToCartButton.hasAttribute('data-atc-initialized')) {
        // 标记已初始化，避免重复绑定
        addToCartButton.setAttribute('data-atc-initialized', 'true')
        
        // 如果全局函数存在，直接初始化
        if (typeof initAddToCart === 'function') {
          initAddToCart(addToCartButton)
        }
      }
    })

    // 处理Shopify section重新加载
    document.addEventListener('shopify:section:load', () => {
      this.init()
    })
  }



  /**
   * 设置产品变体切换功能
   */
  setupVariationSwappers() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('variation-swap')) {
        e.preventDefault();
        this.handleVariationSwap(e.target);
      }
    });
  }

  /**
   * 处理变体切换
   */
  handleVariationSwap(button) {
    const productCard = button.closest('.nm-shop-loop-product-wrap');
    const allSwappers = productCard.querySelectorAll('.variation-swap');
    const priceElement = productCard.querySelector('.product-price');
    const titleElement = productCard.querySelector('.product-card__title');
    const imageElement = productCard.querySelector('.product-card__image');
    const formIdInput = productCard.querySelector('input[name="id"]');
    const addToCartForm = productCard.querySelector('.product-card-form');

    // 更新选中状态
    allSwappers.forEach(swap => swap.classList.remove('selected'));
    button.classList.add('selected');

    // 获取变体数据
    const variantId = button.dataset.variantId;
    const price = button.dataset.price;
    const comparePrice = button.dataset.comparePrice;
    const title = button.dataset.title;
    const image = button.dataset.image;
    const description = button.dataset.description;
    const shippingNote = button.dataset.shippingNote;

    // 更新价格
    if (priceElement && price) {
      priceElement.innerHTML = price;
    }

    // 更新标题
    if (titleElement && title) {
      titleElement.textContent = title;
    }

    // 更新图片
    if (imageElement && image) {
      imageElement.src = image;
      imageElement.alt = title || imageElement.alt;
    }

    // 更新表单中的变体ID
    if (formIdInput && variantId) {
      formIdInput.value = variantId;
    }

    // 更新提交按钮状态 - 使用新的按钮结构
    const submitButton = productCard.querySelector('[data-add-to-cart]');
    if (submitButton) {
      const buttonText = submitButton.querySelector('[data-addtocart-text]');
      const stock = button.dataset.stock;
      const available = button.dataset.available;
      
      if (stock === '0' || available === 'false') {
        submitButton.disabled = true;
        if (buttonText) {
          buttonText.textContent = 'Sold Out';
        }
      } else {
        submitButton.disabled = false;
        if (buttonText) {
          buttonText.textContent = button.dataset.buttonText || 'Buy Now';
        }
      }
    }

    // 更新描述
    const descriptionElement = productCard.querySelector('.nm-shop-loop-description');
    if (descriptionElement && description) {
      descriptionElement.textContent = description;
    }

    // 更新配送说明
    const shippingElement = productCard.querySelector('.product-card__note div');
    if (shippingElement && shippingNote) {
      shippingElement.textContent = shippingNote;
      productCard.querySelector('.product-card__note').style.display = shippingNote ? 'flex' : 'none';
    }

    // 添加切换动画
    this.addSwitchAnimation(productCard);
  }

  /**
   * 添加切换动画效果
   */
  addSwitchAnimation(productCard) {
    productCard.style.transform = 'scale(0.98)';
    productCard.style.transition = 'transform 0.2s ease';
    
    setTimeout(() => {
      productCard.style.transform = 'scale(1)';
      setTimeout(() => {
        productCard.style.transition = '';
        productCard.style.transform = '';
      }, 200);
    }, 100);
  }

  /**
   * 初始化无障碍功能
   */
  setupAccessibility() {
    // 为UGC按钮添加键盘支持
    const ugcButtons = document.querySelectorAll('.nm-shop-loop-product-ugc-button');
    ugcButtons.forEach(button => {
      button.setAttribute('tabindex', '0');
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });

    // 为变体按钮添加键盘支持
    const variationButtons = document.querySelectorAll('.variation-swap');
    variationButtons.forEach(button => {
      button.setAttribute('tabindex', '0');
      button.setAttribute('role', 'button');
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });
  }

  /**
   * 检查浏览器支持
   */
  checkBrowserSupport() {
    // 检查video元素支持
    if (!('HTMLVideoElement' in window)) {
      console.warn('当前浏览器不支持HTML5视频');
      // 隐藏UGC视频按钮
      const ugcButtons = document.querySelectorAll('.nm-shop-loop-product-ugc-button');
      ugcButtons.forEach(button => {
        button.style.display = 'none';
      });
    }

    // 检查 IntersectionObserver 支持（用于懒加载）
    if ('IntersectionObserver' in window) {
      this.setupLazyLoading();
    }
  }

  /**
   * 设置懒加载
   */
  setupLazyLoading() {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            imageObserver.unobserve(img);
          }
        }
      });
    });

    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => imageObserver.observe(img));
  }
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new BirdBuddyProductCard();
});

// 如果是通过AJAX加载的内容，也需要初始化
document.addEventListener('shopify:section:load', () => {
  new BirdBuddyProductCard();
});
